import { useEffect, useState } from 'react'

import { MOBILE_MEDIA_QUERY } from '@percent/workplace-giving/constants/breakpoints'

export function useIsMobile() {
  // Seeded synchronously so the first paint is already correct, rather than
  // rendering a frame of the desktop layout on a phone.
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_MEDIA_QUERY).matches)

  useEffect(() => {
    const query = window.matchMedia(MOBILE_MEDIA_QUERY)
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)

    setIsMobile(query.matches)
    query.addEventListener('change', handleChange)

    return () => query.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}
